import React from "react";
import { BoldSmallerParagraph } from "../../../Components";
import { formatMoney } from "../../../utils/money";

export const OrderMatrixRow = ({ total, currency, color, length }) => {
  if (!total || !total[length] || !currency) return null;
  return (
    <div style={{ minWidth: 80 }}>
      <BoldSmallerParagraph>
        {formatMoney(total[length][color.code] || 0, currency || "EUR")}
      </BoldSmallerParagraph>
    </div>
  );
};

export default OrderMatrixRow;
